import type { HelpFile } from '../../types/help'
import { RequestDetailTestIds } from '../../../testids/RequestDetailTestIds'

export const requestDetailHelp: HelpFile = {
  docPage: '/docs/observability/request-inspector',
  texts: {
    [RequestDetailTestIds.requestDetailPage]:
      'Inbound HTTP request detail — timing, SQL activity, and the call tree of triggered operations.',
    [RequestDetailTestIds.cardTitleWaterfall]:
      'Waterfall chart showing each downstream span along the request timeline.',
  },
}
